/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_UnsupportedInputs */

const th_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เบราว์เซอร์นี้ไม่รองรับวิดีโอสด ลองใช้เบราว์เซอร์อื่น`)
};

const en_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser cannot process live video. Try another browser.`)
};

const ja_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このブラウザーはライブ映像に対応していません。別のブラウザーをお試しください。`)
};

const zh_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此浏览器无法播放实时视频。请换一个浏览器。`)
};

const es_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este navegador no puede procesar vídeo en directo. Prueba con otro.`)
};

const pt_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este navegador não consegue processar vídeo ao vivo. Tente outro navegador.`)
};

const id_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peramban ini tidak bisa memutar video langsung. Coba peramban lain.`)
};

const fr_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce navigateur ne peut pas traiter la vidéo en direct. Essayez-en un autre.`)
};

const tl_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi kayang magpatugtog ng live na video ng browser na ito. Sumubok ng iba.`)
};

const vi_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trình duyệt này không phát được video trực tiếp. Hãy thử trình duyệt khác.`)
};

const ko_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 브라우저는 실시간 영상을 재생할 수 없습니다. 다른 브라우저를 써 보세요.`)
};

const de_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Browser kann kein Live-Video verarbeiten. Versuche einen anderen.`)
};

const ru_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот браузер не может воспроизводить прямой эфир. Попробуйте другой.`)
};

const tr_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu tarayıcı canlı görüntü oynatamıyor. Başka birini deneyin.`)
};

const it_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo browser non può riprodurre video in diretta. Provane un altro.`)
};

const pl_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta przeglądarka nie odtworzy obrazu na żywo. Spróbuj innej.`)
};

const uk_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей браузер не може відтворювати прямий ефір. Спробуйте інший.`)
};

const hi_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह ब्राउज़र लाइव वीडियो नहीं चला सकता। कोई दूसरा आज़माएँ।`)
};

const ar_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا المتصفح لا يشغّل البث المباشر. جرّب متصفحًا آخر.`)
};

const ms_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelayar ini tidak boleh memainkan video langsung. Cuba yang lain.`)
};

const bn_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই ব্রাউজার সরাসরি ভিডিও চালাতে পারে না। অন্যটি দেখুন।`)
};

const zh_tw2_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個瀏覽器無法播放即時影片。請換一個瀏覽器。`)
};

const zh_hk2_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個瀏覽器無法播放即時短片。請換一個瀏覽器。`)
};

const ur_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ براؤزر براہ راست ویڈیو نہیں چلا سکتا۔ کوئی اور آزمائیں۔`)
};

const fa_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`این مرورگر نمی‌تواند تصویر زنده پخش کند. مرورگر دیگری بیازمایید.`)
};

const sw_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kivinjari hiki hakiwezi kucheza video ya moja kwa moja. Jaribu kingine.`)
};

const nl_video_unsupported = /** @type {(inputs: Video_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze browser kan geen live video afspelen. Probeer een andere.`)
};

/**
* | output |
* | --- |
* | "This browser cannot process live video. Try another browser." |
*
* @param {Video_UnsupportedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_unsupported = /** @type {((inputs?: Video_UnsupportedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_UnsupportedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_unsupported(inputs)
	if (locale === "ja") return ja_video_unsupported(inputs)
	if (locale === "zh") return zh_video_unsupported(inputs)
	if (locale === "es") return es_video_unsupported(inputs)
	if (locale === "pt") return pt_video_unsupported(inputs)
	if (locale === "id") return id_video_unsupported(inputs)
	if (locale === "fr") return fr_video_unsupported(inputs)
	if (locale === "tl") return tl_video_unsupported(inputs)
	if (locale === "vi") return vi_video_unsupported(inputs)
	if (locale === "ko") return ko_video_unsupported(inputs)
	if (locale === "de") return de_video_unsupported(inputs)
	if (locale === "ru") return ru_video_unsupported(inputs)
	if (locale === "tr") return tr_video_unsupported(inputs)
	if (locale === "it") return it_video_unsupported(inputs)
	if (locale === "pl") return pl_video_unsupported(inputs)
	if (locale === "uk") return uk_video_unsupported(inputs)
	if (locale === "hi") return hi_video_unsupported(inputs)
	if (locale === "ar") return ar_video_unsupported(inputs)
	if (locale === "ms") return ms_video_unsupported(inputs)
	if (locale === "bn") return bn_video_unsupported(inputs)
	if (locale === "zh-TW") return zh_tw2_video_unsupported(inputs)
	if (locale === "zh-HK") return zh_hk2_video_unsupported(inputs)
	if (locale === "ur") return ur_video_unsupported(inputs)
	if (locale === "fa") return fa_video_unsupported(inputs)
	if (locale === "sw") return sw_video_unsupported(inputs)
	if (locale === "nl") return nl_video_unsupported(inputs)
	return en_video_unsupported(inputs)
});